import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useButtonVisibility } from "@/hooks/useButtonVisibility";
import { ShoppingCart, RefreshCw, RotateCcw, Calculator, Settings, Package, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export const ButtonVisibilitySettings = () => {
  const { buttonVisibility, handleToggleVisibility } = useButtonVisibility();

  const handleToggle = async (buttonId: string) => {
    try {
      await handleToggleVisibility(buttonId);
      const action = !buttonVisibility[buttonId as keyof typeof buttonVisibility] ? "masqué" : "affiché";
      toast.success(`Le bouton a été ${action} avec succès`);
    } catch (error) {
      console.error("Erreur lors du changement de visibilité:", error);
      toast.error("Erreur lors du changement de visibilité du bouton");
    }
  };

  const buttons = [
    { id: 'cart', label: 'Panier', icon: ShoppingCart },
    { id: 'restock', label: 'Réapprovisionner', icon: RefreshCw },
    { id: 'return', label: 'Retourner', icon: RotateCcw },
    { id: 'quantity', label: 'Quantité', icon: Calculator },
    { id: 'actions', label: 'Actions', icon: Settings },
    { id: 'inventory', label: 'Inventaire', icon: Package },
    { id: 'loss', label: 'Perte', icon: AlertTriangle },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Visibilité des boutons - Gestion de stock</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {buttons.map((button) => {
            const Icon = button.icon;
            return (
              <div key={button.id} className="flex items-center justify-between p-2 rounded-lg border">
                <div className="flex items-center gap-2">
                  <Icon className="h-5 w-5 text-muted-foreground" />
                  <Label htmlFor={button.id}>{button.label}</Label>
                </div>
                <Switch
                  id={button.id}
                  checked={buttonVisibility[button.id as keyof typeof buttonVisibility]}
                  onCheckedChange={() => handleToggle(button.id)}
                />
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};